class DeliveryPromise extends HTMLElement {
  connectedCallback() {
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.controller = new AbortController();
    this.update = () => {
      window.clearInterval(this.timer);
      this.removeAttribute('data-free');
      if (this.motion.matches || document.hidden) return;
      this.timer = window.setInterval(() => this.toggleAttribute('data-free'), 10000);
    };
    document.addEventListener('visibilitychange', this.update, { signal: this.controller.signal });
    this.motion.addEventListener('change', this.update, { signal: this.controller.signal });
    this.update();
  }
  disconnectedCallback() {
    window.clearInterval(this.timer);
    this.controller?.abort();
  }
}
if (!customElements.get('delivery-promise')) customElements.define('delivery-promise', DeliveryPromise);
